import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { FieldType } from 'modules/reports/components/Editor/Field/types'

const getGroupingOptionsLabel = (type: string) => {
  switch (type) {
    case 'day':
      return i18n.t('custom_reports.grouping_options.day')
    case 'month':
      return i18n.t('custom_reports.grouping_options.month')
    case 'year':
      return i18n.t('custom_reports.grouping_options.year')
    default:
      throw new Error(`Unknown translation for type: ${type}`)
  }
}

interface Props {
  fieldType: FieldType
}

const GroupingInfo = ({ fieldType }: Props) => {
  const value = fieldType.form.get('group').value

  return (
    <Box flexDirection="row">
      <Text.Normal color="grey1000" size="200" weight="medium">
        {i18n.t('custom_reports.ability_labels.group_by')}:&nbsp;
      </Text.Normal>
      <Text.Normal color="grey1000" size="200">
        {getGroupingOptionsLabel(value ?? '')}
      </Text.Normal>
    </Box>
  )
}

export default observer(GroupingInfo)
